import React from "react";
import {
  EngagementChosenAnswer,
  TrainingCenterBundleItemVideoEngagementQuestion,
} from "../../system/AppState/AppStateTrainingCenter";
import {
  lookupTranslationRequired,
  TrainingCenterLanguagePreference,
} from "./TrainingCenterLanguageLookup";
import TrainingCenterVideoEngagementQuestionResultFail from "./TrainingCenterVideoEngagementQuestionResultFail";
import TrainingCenterVideoEngagementQuestionResultSuccess from "./TrainingCenterVideoEngagementQuestionResultSuccess";

interface Props {
  question: TrainingCenterBundleItemVideoEngagementQuestion;
  chosenAnswer: EngagementChosenAnswer;
  languagePreference: TrainingCenterLanguagePreference;
}

const TrainingCenterVideoEngagementQuestionResult = ({
  question,
  chosenAnswer,
  languagePreference,
}: Props) => {
  const answers = React.useMemo(() => {
    return lookupTranslationRequired(languagePreference, question.displayData, (x) => x)
      .questionAnswers;
  }, [languagePreference, question]);

  const isAnswerCorrect = React.useMemo(() => {
    return answers[0] === chosenAnswer.value;
  }, [answers, chosenAnswer.value]);

  return (
    <div className="TrainingCenterVideoEngagementQuestionResult">
      {isAnswerCorrect ? (
        <TrainingCenterVideoEngagementQuestionResultSuccess />
      ) : (
        <TrainingCenterVideoEngagementQuestionResultFail />
      )}
    </div>
  );
};

export default React.memo(TrainingCenterVideoEngagementQuestionResult);
